<template>
  <v-app>
    <v-main>
      <table-component></table-component>
	  <div id="aa"></div>
    </v-main>
  </v-app>
</template>

<script>
import TableComponent from './components/TableComponent'
export default {
  name: 'App',

  components: {
    TableComponent,
  },
	mounted() {
		const vm = this;
	},
  data: () => ({
	nowe: [],
	arr: []
  }),
};
</script>
<style lang="scss">
	html{
	}
	#aa{
		@include xs{
			display: none;
		}
	}
</style>